(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-top-buttons"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const selectors = {
    filteredCollections: '#FilteredCollections',
    headerReceptor: '#SiteHeader .page-width',
    filterButtons: '.btncoll-container__filter-wrapper label',
    filterSections: '[data-filter-type]',
    filterRadios: '.btncoll-container__filter-wrapper label input[type="radio"][name="filter"]',
    sectionBottles: document.querySelector('#bottles'),
    sectionTumblers: document.querySelector('#tumblers'),
    sectionAccessories: document.querySelector('#accessories')
  }

  const filteredCollections = document.querySelector(selectors.filteredCollections);
  const headerReceptor = document.querySelector(selectors.headerReceptor);
  const filterButtons = document.querySelectorAll(selectors.filterButtons);
  const filterSections = document.querySelectorAll(selectors.filterSections);
  const filterRadios = document.querySelectorAll(selectors.filterRadios);

  function injectFilterInHeader(){
    headerReceptor.append(filteredCollections);
  }

  function handleFilterSections(currentFilter){
    if(currentFilter === 'all'){
      const filterSectionsVisible = document.querySelectorAll(`[data-filter-type]`);
      filterSectionsVisible.forEach(filterSectionVisible => { 
        if (filterSectionVisible.classList.contains('btncoll-container__section--hidden')) {
          filterSectionVisible.classList.remove('btncoll-container__section--hidden');
        }
      });
    } else {
      filterSections.forEach(filterSection => { 
        if (!filterSection.classList.contains('btncoll-container__section--hidden')) {
          filterSection.classList.add('btncoll-container__section--hidden');
        }
      });
      const filterSectionsVisible = document.querySelectorAll(`[data-filter-type="${currentFilter.toLowerCase()}"]`);
      filterSectionsVisible.forEach(filterSectionVisible => { 
        if (filterSectionVisible.classList.contains('btncoll-container__section--hidden')) {
          filterSectionVisible.classList.remove('btncoll-container__section--hidden');
        }
      });
    }
  }

  function checkSelectedOption(){
    let selectedFilter;
    for (const radio of filterRadios) {
      if (radio.checked) {
        selectedFilter = radio.value;
        break;
      }
    }
    handleFilterSections(selectedFilter);
  }

  function initFilteredCollection(){ 
    injectFilterInHeader();
    checkSelectedOption();
    filterButtons.forEach(button => { 
      button.addEventListener("click", ()=>{handleFilterSections(button.querySelector('input').value)});
    });
  }

  function handleScroll() {
    const fromTop = window.scrollY;
    const isMobile = window.innerWidth <= 768; // Define the breakpoint for mobile
    const offset = isMobile ? 600 : 400; // Adjust this value as needed
    const sections = [
      { section: document.querySelector('#bottles'), button: document.querySelector('.btncoll[href="/pages/shop-all#bottles"]') },
      { section: document.querySelector('#tumblers'), button: document.querySelector('.btncoll[href="/pages/shop-all#tumblers"]') },
      { section: document.querySelector('#accessories'), button: document.querySelector('.btncoll[href="/pages/shop-all#accessories"]') }
    ];

    sections.forEach(({ section, button }) => {
      const sectionTop = section.offsetTop - offset;
      const sectionHeight = section.offsetHeight;
      if (fromTop >= sectionTop && fromTop < sectionTop + sectionHeight) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }

  function removeFocusAfterClick(buttons) {
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        button.blur();
      });
    });
  }

  window.addEventListener('scroll', handleScroll);
  initFilteredCollection();
  removeFocusAfterClick(document.querySelectorAll('.btncoll'));

  document.addEventListener('shopify:section:load', function(event) {
    initFilteredCollection();
    removeFocusAfterClick(document.querySelectorAll('.btncoll'));
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtered-collections"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    
    const selectors = {
      filteredCollections: '#FilteredCollections',
      headerReceptor: '#SiteHeader .page-width',
      filterButtons: '.filtered-collections__filter-wrapper label',
      filterSections: '[data-filter-type]',
      filterRadios: '.filtered-collections__filter-wrapper label input[type="radio"][name="filter"]'
    }

    const filteredCollections = document.querySelector(selectors.filteredCollections)
    const headerReceptor = document.querySelector(selectors.headerReceptor)
    const filterButtons = document.querySelectorAll(selectors.filterButtons)
    const filterSections = document.querySelectorAll(selectors.filterSections)
    const filterRadios = document.querySelectorAll(selectors.filterRadios);

    function injectFilterInHeader(){
      headerReceptor.append(filteredCollections)   
    }

    function handleFilterSections(currentFilter){
      if(currentFilter === 'all'){
        const filterSectionsVisible = document.querySelectorAll(`[data-filter-type]`)
        filterSectionsVisible.forEach(filterSectionVisible => { 
          if (filterSectionVisible.classList.contains('filtered-collections__section--hidden')) {
            filterSectionVisible.classList.remove('filtered-collections__section--hidden');
          }
        }) 
      }
      else {
        filterSections.forEach(filterSection => { 
        if (!filterSection.classList.contains('filtered-collections__section--hidden')) {
            filterSection.classList.add('filtered-collections__section--hidden');
          }
        })
        const filterSectionsVisible = document.querySelectorAll(`[data-filter-type="${currentFilter.toLowerCase()}"]`)
        filterSectionsVisible.forEach(filterSectionVisible => { 
          if (filterSectionVisible.classList.contains('filtered-collections__section--hidden')) {
            filterSectionVisible.classList.remove('filtered-collections__section--hidden');
          }
        }) 
      }
    }

    function checkSelectedOption(){
      let selectedFilter;
      for (const radio of filterRadios) {
        if (radio.checked) {
          selectedFilter = radio.value;
          break;
        }
      }
      handleFilterSections(selectedFilter)
    }

    function initFilteredCollection(){ 
      injectFilterInHeader()
      checkSelectedOption()
      filterButtons.forEach(button => { 
        button.addEventListener("click", ()=>{handleFilterSections(button.querySelector('input').value)});
      })
    }

    initFilteredCollection()

    document.addEventListener('shopify:section:load', function(event) {
      initFilteredCollection()
    }) 
    
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-two-colors"]) return;
  try {
    
  const colorPicker = document.getElementById('color-picker');
  const colorSpan = document.getElementById('color-span');

  colorPicker.addEventListener('change', function() {
    colorSpan.style.color = colorPicker.value;
  });

  } catch(e) { console.error(e); }
})();
})();
